import React from 'react';

const AppFooter = (props) => {
    const administracionLogo = localStorage.getItem('administracionLogo') || 'expensas360.png';
    return (
        <div className="layout-footer">
            <div className="footer-logo-container">
                <img id="footer-logo" src={`assets/layout/images/administradoras/${administracionLogo}`} alt="District Manager" />
            </div>
            <span className="copyright">&#169; <a href='https://www.virtualtech.com.ar' target='_blank'>Virtualtech</a> { new Date().getFullYear() }</span>
        </div>
    );
};

export default AppFooter;
